import ValidateField from '../../hooks/useValid';
import { ValidateName } from '../../constants/ValidateNameConstants';
import { ValidateMessages } from '../../constants/ValidateConstants'

export default function validation(values, salesEngineer) {

  const errors = {};

  errors.quoteRef = ValidateField(
    values.quotationId,
    ValidateName?.QUOTE_REF,
    ValidateName?.QUOTE_REF,
    [ValidateName?.REQUIRED],
  );

  errors.distributor = ValidateField(
    values.distributorId,
    ValidateName?.DISTRIBUTOR,
    ValidateName?.DISTRIBUTOR,
    [ValidateName?.ISREQUIRED_NO],
  );

  errors.customer = ValidateField(
    values.customerId,
    ValidateName?.CUSTOMER_NAME,
    ValidateName?.CUSTOMER_NAME,
    [ValidateName?.ISREQUIRED_NO],
  );

  errors.poNumber = ValidateField(
    values.purchaseOrderReference,
    ValidateName?.PO_NUMBER,
    ValidateName?.PO_NUMBER,
    [ValidateName?.REQUIRED],
  );

  errors.poDate = ValidateField(
    values.purchaseOrderDate,
    ValidateName?.PO_DATE,
    ValidateName?.PO_DATE,
    [ValidateName?.REQUIRED],
  );

  errors.project = ValidateField(
    values.projectId,
    ValidateName?.PROJECT_NAME,
    ValidateName?.PROJECT_NAME,
    [ValidateName?.ISREQUIRED_NO],
  );

  errors.contactPerson = ValidateField(
    values.contactPerson,
    ValidateName?.CONTACT_PERSON,
    ValidateName?.CONTACT_PERSON,
    [ValidateName?.REQUIRED],
  );

  errors.deliveryContactNo = ValidateField(
    values.deliveryContactNo,
    ValidateName?.DELIVERY_CONTACT,
    ValidateName?.DELIVERY_CONTACT,
    [ValidateName?.REQUIRED],
  );

  errors.customerAddress = ValidateField(
    values.customerAddress,
    ValidateName?.CUSTOMER_ADDRESS,
    ValidateName?.CUSTOMER_ADDRESS,
    [ValidateName?.REQUIRED],
  );

  errors.email = ValidateField(
    values.emailAddress,
    ValidateName?.EMAIL,
    ValidateName?.EMAIL,
    [ValidateName?.REQUIRED],
  );

  errors.phone = ValidateField(
    values.phone,
    ValidateName?.PHONE_NUMBER,
    ValidateName?.PHONE_NUMBER,
    [ValidateName?.REQUIRED, ValidateName?.ISVALID_PHONE],
  );

  errors.salesEngineer = ValidateField(
    salesEngineer,
    ValidateName?.SALES_ENGINEER,
    ValidateName?.SALES_ENGINEER,
    [ValidateName?.REQUIRED],
  );

  errors.currency = ValidateField(
    values.currencyId,
    ValidateName?.CURRENCY,
    ValidateName?.CURRENCY,
    [ValidateName?.REQUIRED],
  );
  errors.orderType = ValidateField(
    values.orderType,
    ValidateName?.ORDER_TYPE,
    ValidateName?.ORDER_TYPE,
    [ValidateName?.REQUIRED],
  );

  errors.billingCustomer = ValidateField(
    values.billingCustomerId,
    ValidateName?.BILLING_CUSTOMER,
    ValidateName?.BILLING_CUSTOMER,
    [ValidateName?.REQUIRED],
  );

  errors.billingAddress = ValidateField(
    values.billingAddress,
    ValidateName?.BILLING_ADDRESS,
    ValidateName?.BILLING_ADDRESS,
    [ValidateName?.REQUIRED],
  );

  errors.country = ValidateField(
    values.countryId,
    ValidateName?.COUNTRY,
    ValidateName?.COUNTRY,
    [ValidateName?.REQUIRED],
  );

  errors.conversionRate = ValidateField(
    values.conversionRate,
    ValidateName?.CONVERSION_RATE,
    ValidateName?.CONVERSION_RATE,
    [ValidateName?.REQUIRED, ValidateName?.ISVALID_CONVERSION_RATE],
  );


  errors.paymentTerms = ValidateField(
    values.paymentTermId,
    ValidateName?.PAYMENT_TERMS,
    ValidateName?.PAYMENT_TERMS,
    [ValidateName?.ISREQUIRED_NO],
  );
  errors.deliveryLeadTime = ValidateField(
    values.deliveryLeadTimeId,
    ValidateName?.DELIVERY_LEADTIME,
    ValidateName?.DELIVERY_LEADTIME,
    [ValidateName?.ISREQUIRED_NO],
  );
  if (values?.deliveryLeadTimeId === "0" || values?.deliveryLeadTimeId === 0) {
    errors.deliveryLeadTime = ValidateField(
      values.deliveryLeadTime,
      ValidateName?.DELIVERY_LEADTIME,
      ValidateName?.DELIVERY_LEADTIME,
      [ValidateName?.REQUIRED],
    );
  }

  errors.deliveryTerms = ValidateField(
    values.deliveryTermId,
    ValidateName?.DELIVERY_TERMS,
    ValidateName?.DELIVERY_TERMS,
    [ValidateName?.ISREQUIRED_NO],
  );

  if (values?.deliveryTermId === "0" || values?.deliveryTermId === 0) {
    errors.deliveryTerms = ValidateField(
      values.deliveryTerms,
      ValidateName?.DELIVERY_TERMS,
      ValidateName?.DELIVERY_TERMS,
      [ValidateName?.REQUIRED],
    );
  }

  errors.modeOfTransport = ValidateField(
    values.modeOfTransportId,
    ValidateName?.MODE_OF_TRANSFORT,
    ValidateName?.MODE_OF_TRANSFORT,
    [ValidateName?.ISREQUIRED_NO],
  );

  let error = {}
  Object.keys(errors).map((key, index) => {
    if (errors[key] !== undefined)
      error[key] = errors[key]
  })
  return error;
}

export function ForecastRequiredvalidation(values) {

  const errors = {};

  errors.expectedAmount = ValidateField(
    values.expectedAmount,
    ValidateName?.EXPECTED_AMOUNT,
    ValidateName?.EXPECTED_AMOUNT,
    [ValidateName?.REQUIRED],
  );

  errors.expectedQuantity = ValidateField(
    values.expectedQuantity,
    ValidateName?.EXPECTED_QUANTITY,
    ValidateName?.EXPECTED_QUANTITY,
    [ValidateName?.REQUIRED, ValidateName?.ISPOSITIVENUMBER],
  );

  let error = {}
  Object.keys(errors).map((key, index) => {
    if (errors[key] !== undefined)
      error[key] = errors[key]
  })

  return error;
}

export function Forecastvalidation(quantity, amount, currentForecast) {
  const errors = {};
  if (Number(quantity) > Number(currentForecast?.quantity)) {
    errors.quantity = ValidateMessages?.FORECAST_QUANTITY;
  }

  if (Number(Number(amount).toFixed(2)) > Number(Number(currentForecast?.quotedAmount).toFixed(2))) {
    errors.quotedAmount = ValidateMessages?.FORECAST_AMOUNT;
  }

  let error = {}
  Object.keys(errors).map((key, index) => {
    if (errors[key] !== undefined)
      error[key] = errors[key]
  })

  return error;
}
